var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78,
    width: 18,
    height: 18,
    rx: 3,
    fill: "#C7BEE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 58,
    width: 22,
    height: 38,
    rx: 3,
    fill: "#A99CD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 38,
    width: 22,
    height: 58,
    rx: 3,
    fill: "#8B7AC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 18,
    width: 22,
    height: 78,
    rx: 3,
    fill: "#6E5BAE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 2,
    width: 22,
    height: 94,
    rx: 3,
    fill: "#4A35A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 88 Q40 65 65 55 Q85 47 105 22",
    stroke: "#4A35A0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 18 L108 20 L104 30",
    stroke: "#4A35A0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    opacity: 0.6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 75,
    fontFamily: "'Inter','Nunito Sans','Segoe UI',sans-serif",
    fontSize: 52,
    fontWeight: 800,
    fill: "#1A1A2E",
    letterSpacing: -1
  }, "Tajer")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 75,
    fontFamily: "'Inter','Nunito Sans','Segoe UI',sans-serif",
    fontSize: 52,
    fontWeight: 400,
    fill: "#1A1A2E",
    letterSpacing: -1
  }, "Pro")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.100e61c6e2be9314fae67b38c155dc37.svg";
export { ForwardRef as ReactComponent };